import { Component, OnInit, Inject } from '@angular/core';
import { FaqService } from 'src/app/shared/services/faq.service';
//import { NotificationService } from 'src/app/shared/services/notification.service';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
//import { ToastrService } from 'ngx-toastr';
//import { IssueService } from 'src/app/shared/services/issue.service';
//import { IssueTrackService } from 'src/app/shared/services/issue-track.service';
import { FaQFileModel, IssueFileModel, IssueTrackDetailModel } from 'src/app/shared/models/issue.model';
//import { FormGroup } from '@angular/forms';
import { FaQModel } from 'src/app/shared/models/faq.model';
//import { prepareEventListenerParameters } from '@angular/compiler/src/render3/view/template';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/shared/services/user.service';
import { FaqEditComponent } from '../faq-edit/faq-edit.component';

@Component({
  selector: 'app-faq-detail',
  templateUrl: './faq-detail.component.html',
  styleUrls: ['./faq-detail.component.css']
})
export class FaqDetailComponent implements OnInit {
  private sub: any;
  id: string;
  thisData : FaQModel;
  ifiles : IssueFileModel []; // issue files
  sfiles : IssueFileModel []; // solution files
  modalImage : string;
  dialogConfig = new MatDialogConfig();

  constructor(
    private userService : UserService,
    private route: ActivatedRoute,
   // private issueService: IssueService,
   // private solutionService: IssueTrackService,
    private service: FaqService,
   // private toastr : ToastrService,
    private dialog : MatDialog) {
      console.log("constructor : FaqDetailComponent");

      this.dialogConfig.disableClose = true;
      this.dialogConfig.autoFocus = true;
      this.dialogConfig.width = "60%";
    }

  ngOnInit() {

    this.sub = this.route.params.subscribe(params => {
      // this.id = +params['id']; // (+) converts string 'id' to a number
       this.id = params['id'];

       console.log("id : " + this.id);

       if(this.id != null)
       {
        this.loadData();
       }
       // In a real app: dispatch action to load the details here.
    });

    console.log("ngOnInit : FaqDetailComponent");

  }

  loadData()
  {
      this.service.getDetail(this.id).subscribe(
        res=>{
            this.thisData  = res as FaQModel;
            this.service.getFaqFileList(this.id).subscribe(
            res=>{
              var files = res as FaQFileModel[];
              console.log(files.length);
              //if(!this.ifiles) this.ifiles = new Array<IssueFileModel>();
              //if(!this.sfiles) this.sfiles = new Array<IssueFileModel>();
              this.ifiles = new Array<IssueFileModel>();
              this.sfiles = new Array<IssueFileModel>();

              files.forEach(item => {
                if(item.type == '0')
                  this.ifiles.push(item);
                else
                  this.sfiles.push(item);
              });


            },
            err=>{}
          );
        },
        err=>{

        }

      );
  }

  onEdit()
  {
    this.dialogConfig.data = {
      id : this.thisData.faqId,
      result : false
    };
    let dialogRef = this.dialog.open(FaqEditComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      if(this.dialogConfig.data.result)
      {
        console.log(true);
        this.loadData();

      }
      else{
        console.log(false);
      }
    });

  }

  openModal(imagelink) {

    this.modalImage = imagelink;

    console.log(this.modalImage);
    document.getElementById('imgModal').style.display = "block";

  }

  closeModal() {
    document.getElementById('imgModal').style.display = "none";
  }
}

